import { Component, EventEmitter, OnInit, Output } from '@angular/core';
declare let $: any;
@Component({
  selector: 'app-hyderabad',
  templateUrl: './hyderabad.component.html',
  styleUrls: ['./hyderabad.component.scss']
})
export class HyderabadComponent implements OnInit {
  @Output() childEvent = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  openModal(id, seat): void {
    // $(id).modal('show');
    this.childEvent.emit(seat);
    console.log(seat);
  }
  // tslint:disable-next-line: member-ordering
  numb: any = [
    {
      n: '1',
      xy: '91px 0 0 421px'
    },
    {
      n: '2',
      xy: '-38px 0 0 455px'
    },
    {
      n: '3',
      xy: '-71px 0 0 488px'
    },
    {
      n: '4',
      xy: '-13px 0 0 421px'
    },
    {
      n: '5',
      xy: '-45px 0 0 455px'
    },
    {
      n: '6',
      xy: '-83px 50px 0 488px'
    },
    {
      n: '7',
      xy: '2px 0 0 56px'
    },
    {
      n: '8',
      xy: '2px 0 0 78px'
    },
    {
      n: '9',
      xy: '2px 0 0 37px'
    },
    {
      n: '10',
      xy: '0px 0 0 180px'
    },
    {
      n: '11',
      xy: '4px 50px 0 35px'
    },
    {
      n: '12',
      xy: '40px 0 0 56px'
    },
    {
      n: '13',
      xy: '40px 0 0 78px'
    },
    {
      n: '14',
      xy: '40px 0 0 37px'
    },
    {
      n: '15',
      xy: '64px 0 0 213px'
    },
    {
      n: '16',
      xy: '64px 0 0 12px'
    },
    {
      n: '17',
      xy: '64px 0 0 12px'
    },
    {
      n: '18',
      xy: '64px 0 0 10px'
    },
    {
      n: '19',
      xy: '23px 0 0 56px'
    },
    {
      n: '20',
      xy: '23px 0 0 78px'
    },
    {
      n: '21',
      xy: '23px 0 0 37px'
    },
    {
      n: '22',
      xy: '30px 0 0 213px'
    },
    {
      n: '23',
      xy: '30px 0 0 12px'
    },
    {
      n: '24',
      xy: '30px 0 0 12px'
    },
    {
      n: '25',
      xy: '30px 0 0 10px'
    },
    {
      n: '26',
      xy: '18px 0 0 56px'
    },
    {
      n: '27',
      xy: '18px 365px 0 78px'
    },
    {
      n: '28',
      xy: '25px 0 0 401px'
    },
    {
      n: '29',
      xy: '26px 80px 0 40px'
    },
    {
      n: '30',
      xy: '42px 0 0 57px'
    },
    {
      n: '31',
      xy: '40px 0 0 78px'
    },
    {
      n: '32',
      xy: '25px 340px 0 32px'
    },
    {
      n: '33',
      xy: '36px 0 0 57px'
    },
    {
      n: '34',
      xy: '38px 0 0 78px'
    },
    {
      n: '35',
      xy: '25px 0 0 32px'
    },
    {
      n: '36',
      xy: '-15px 0 0 168px'
    },
    {
      n: '37',
      xy: '-15px 0 0 40px'
    },
    {
      n: '38',
      xy: '-15px 0 0 40px'
    },
    {
      n: '39',
      xy: '54px 0 0 57px'
    },
    {
      n: '40',
      xy: '54px 0 0 78px'
    },
    {
      n: '41',
      xy: '9px 0 0 32px'
    },
    {
      n: '42',
      xy: '5px 0 0 259px'
    },
    {
      n: '43',
      xy: '-11px 0 0 29px'
    },
    {
      n: '44',
      xy: '38px 0 0 57px'
    },
    {
      n: '45',
      xy: '38px 0 0 78px'
    },
    {
      n: '46',
      xy: '-9px 0 0 37px'
    },
    {
      n: '47',
      xy: '-51px 0 0 290px'
    },
    {
      n: '48',
      xy: '50px 0 0 200px'
    },
  ];

}
